import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import {io} from 'socket.io-client';
const root = ReactDOM.createRoot(document.getElementById('root'));
//const messages = ReactDOM.createRoot(document.getElementById('messages')); // document.getElementById('messages');


root.render(
  <React.StrictMode>
    <App  />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
